import { LoginFields } from "../../models/interface";

export const loginForm = () => {
  return {
    email: {
      value: "",
      error: "",
    },
    password: {
      value: "",
      error: "",
    },
  } as LoginFields;
};

export const loginValidation = (loginUserData: any, text: any) => {
  let errors = {
    ...loginUserData,
    email: { ...loginUserData.email },
    password: { ...loginUserData.password },
  };

  let isValid = true;

  const emailRaw = loginUserData.email.value;
  const passwordRaw = loginUserData.password.value;

  if (!emailRaw || emailRaw.trim().length === 0) {
    errors.email.error = text.general.email;
    isValid = false;
  } else {
    errors.email.error = "";
  }

  if (!passwordRaw || passwordRaw.trim().length === 0) {
    errors.password.error = text.general.password;
    isValid = false;
  } else {
    errors.password.error = "";
  }

  return { isValid, errors };
};

export const mfaValidation = (fields: any, text: any) => {
  let errors = fields;
  let isValid = true;
  if (!fields.mfa.value) {
    errors.mfa.error = text.general.mfaCode;
    isValid = false;
  }
  return { isValid, errors };
};
